import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import RemoveComas from "../views/RemoveComas.vue";
import AddComas from "../views/AddComas.vue"; // Import the AddComas component
import SgdeToAed from "../views/SgdeToAed.vue";
import VcxToAed from "../views/VcxToAed.vue";
import ReportBug from "../views/ReportBug.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/remove-comas",
    name: "remove-comas",
    component: RemoveComas,
  },
  {
    path: "/add-comas",
    name: "add-comas",
    component: AddComas, // Add a route for AddComas
  },
  {
    path: "/sgde-to-aed",
    name: "sgde-to-aed",
    component: SgdeToAed,
  },
  {
    path: "/vcx-to-aed",
    name: "vcx-to-aed",
    component: VcxToAed,
  },
  {
    path: "/report-bug",
    name: "report-bug",
    component: ReportBug,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
